import { render, staticRenderFns } from "./Groups.html?vue&type=template&id=8faa6a4e&scoped=true&"
import script from "./Groups.js?vue&type=script&lang=js&"
export * from "./Groups.js?vue&type=script&lang=js&"
import style0 from "./Groups.scss?vue&type=style&index=0&id=8faa6a4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8faa6a4e",
  null
  
)

export default component.exports